module.exports = __webpack_public_path__ + "static/media/wallet_terms_kh_KH.e79441e7.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/wallet_terms_kh_KH.md
// module id = 107
// module chunks = 0